import { Box, Button, Grid, TextField, Typography } from "@mui/material";
import { useState, useEffect } from "react";
import useButtonStyles from "../../styles/useButtonStyles";
import theme from "../../theme";
import { Link } from "react-router-dom";
import { APIConstants } from "../../constants/ApiConstants";
import axios from "axios";
import BasicTextField from "../forms/formElements/BasicTextField";
import { AddRoleData } from "../../static-models/RoleFormData";
import { constant } from "../../constants";
import { useDispatch } from "react-redux";
import { useAppSelector } from "../../redux/hooks";
import { roleActions } from "../../redux/slices/roleSlice";
import { Description } from "@mui/icons-material";
import BasicModal from "../ui/BasicModal";
import Loader from "../ui/Loader";

export interface IAppProps {}

export interface AddRoleFormProps {
  initialFormData: AddRoleFormDataType;
}
export interface AddRoleFormDataType {
  name: string;
  description: string;
}

export function RoleTable(props: AddRoleFormProps) {
  const [showModal, setShowModal] = useState<boolean>(false);
  const [uploadError, setUploadError] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const { initialFormData } = props;
  const [clearForm, setClearForm] = useState(false);
  const [isReferesh, setIsReferesh] = useState(false);
  const buttonStyles = useButtonStyles();
  const [roleFormState, setRoleFormState] =
    useState<AddRoleFormDataType>(initialFormData);
  const dispatch = useDispatch();
  let roleList = useAppSelector(
    (state: any) => state.persistReducers.getRoleList.roleList
  );
  const [title, setTitle] = useState("");

  useEffect(() => {
    const fetchRoleList = async () => {
      try {
        roleList.length > 0 ? setLoading(false) : setLoading(true);
        const response = await axios.get(
          process.env.REACT_APP_API_URL + APIConstants.role
        );
        const data = response.data.data;

        const roleListData = data.map((item: any) => {
          return {
            name: item.name ? item.name : "-",
            description: item.description ? item.description : "-",
          };
        });
        dispatch(roleActions.updateRoleList({ roleList: roleListData }));
        setLoading(false);
        setUploadError(false);
      } catch (error) {
        console.error(error);
        setLoading(false);
        setUploadError(false);
        console.error("Error");
      }
    };

    fetchRoleList();
  }, [isReferesh, dispatch, roleList.length, setLoading, setUploadError]);

  const addRole = async () => {
    setLoading(true);
    const payload: any = roleFormState;
    try {
      const axiosResponse = await axios.post(
        process.env.REACT_APP_API_URL + APIConstants.role,
        payload
      );
      setIsReferesh(!isReferesh);
      setUploadError(false);
      setTitle("Added User Successfully");
    } catch (error) {
      setUploadError(true);
    } finally {
      setLoading(false);
      setShowModal(true);
      setClearForm(true);
      setTimeout(() => {
        setClearForm(false);
      }, 2000);
    }
  };

  const deleteRole = async (name: string) => {
    setLoading(true);
    try {
      const axiosResponse = await axios.delete(
        process.env.REACT_APP_API_URL + APIConstants.role + "?name=" + name
      );
      setIsReferesh(!isReferesh);
      setUploadError(false);
      setTitle("Deleted User Successfully ");
    } catch (error) {
      setUploadError(true);
    } finally {
      setLoading(false);
      setShowModal(true);
      setClearForm(true);
      setTimeout(() => {
        setClearForm(false);
      }, 2000);
    }
  };

  const updateRoles = async () => {
    setLoading(true);
    try {
      const axiosResponse = await axios.patch(
        process.env.REACT_APP_API_URL + APIConstants.role,
        roleList
      );
      setUploadError(false);
      setIsReferesh(!isReferesh);
      setTitle("Updated User Successfully");
    } catch (error) {
      setUploadError(true);
    } finally {
      setLoading(false);
      setShowModal(true);
      setClearForm(true);
      setTimeout(() => {
        setClearForm(false);
      }, 2000);
    }
  };

  const submitHandler = async (e: React.SyntheticEvent) => {
    e.preventDefault();
    await addRole();
    setRoleFormState(AddRoleData);
    setClearForm(true);
    setTimeout(() => {
      setClearForm(false);
    }, 2000);
  };

  return (
    <Grid
      sx={{
        backgroundColor: theme?.color?.background,
        borderRadius: "8px",
      }}
      padding={2}
    >
      <Grid
        container
        component={"form"}
        display={"flex"}
        onSubmit={submitHandler}
        alignItems={"flex-end"}
        justifyContent={"space-evenly"}
        width={"100%"}
        borderBottom={`${theme?.border?.xsmall}${theme.color?.dividerLight}`}
        paddingBottom={2}
        padding={2}
        marginBottom={2}
      >
        <Grid item width={"30%"} padding={1}>
          <Typography
            mb={1}
            sx={{ fontFamily: theme.font?.fontFamily.primary }}
          >
            Roles
          </Typography>
          <BasicTextField
            placeholder=""
            stateKey="name"
            setState={setRoleFormState}
            clear={clearForm}
          />
        </Grid>
        <Grid item width={"55%"} padding={1}>
          <Typography
            mb={1}
            sx={{ fontFamily: theme.font?.fontFamily.primary }}
          >
            Roles Description
          </Typography>
          <BasicTextField
            placeholder=""
            stateKey="description"
            setState={setRoleFormState}
            clear={clearForm}
          />
        </Grid>
        <Grid
          item
          display={"flex"}
          // justifyContent={"center"}
          width={"15%"}
          padding={1}
        >
          <Button
            sx={{ ...buttonStyles.outlinedSecondary }}
            variant="outlined"
            type="submit"
            fullWidth
          >
            Add Role
          </Button>
        </Grid>
      </Grid>

      {roleList.map((role: AddRoleFormDataType, index: number) => {
        return (
          <Grid
            key={role.name}
            item
            container
            justifyContent={"space-evenly"}
            pl={2}
            pr={2}
          >
            <Grid item width={"30%"} padding={1}>
              <TextField
                sx={{ width: "100%" }}
                size="small"
                defaultValue={role.name}
                disabled={true}
              ></TextField>
            </Grid>
            <Grid item width={"55%"} padding={1}>
              <TextField
                sx={{ width: "100%" }}
                size="small"
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                  const description = e.target.value;
                  const list = [...roleList];
                  list[index] = { ...list[index], description };
                  roleList = list;
                }}
                defaultValue={role.description}
              ></TextField>
            </Grid>
            <Grid
              item
              display={"flex"}
              alignItems={"center"}
              justifyContent={"center"}
              width={"15%"}
              padding={1}
            >
              <Button
                onClick={() => deleteRole(role.name)}
                color="error"
                variant="text"
                sx={{
                  fontSize: theme.font?.fontSize.tableBody,
                  textAlign: "center",
                }}
              >
                <Box component={"img"} src="/DeleteIcon.svg" sx={{ mr: 0.8 }} />
                Delete Role
              </Button>
            </Grid>
          </Grid>
        );
      })}
      <Grid
        container
        marginTop={4}
        item
        justifyContent={"end"}
        padding={2}
        borderTop={`${theme?.border?.xsmall}${theme.color?.dividerLight}`}
      >
        <Button
          sx={{ ...buttonStyles.outlinedSecondary, width: "25%", mr: 2 }}
          variant="outlined"
          component={Link}
          to="/admin"
        >
          Cancel
        </Button>
        <Button
          onClick={() => updateRoles()}
          sx={{ ...buttonStyles.containedSecondary, width: "25%" }}
          variant="contained"
        >
          Update
        </Button>
      </Grid>
      {showModal &&
        (uploadError ? (
          <BasicModal
            title={"Something went wrong"}
            success={false}
            setState={setShowModal}
          />
        ) : (
          <BasicModal title={title} success={true} setState={setShowModal} />
        ))}
      {loading && <BasicModal content={<Loader />} />}
    </Grid>
  );
}
